/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { InlineMessageComponent } from './inline-message';
export * from './inline-message-constants';
export * from './inline-message';
export function defineInlineMessageComponent() {
    defineCustomElement(InlineMessageComponent);
}
